

























import Vue from "vue";
import Component from "vue-class-component";
import FeatureTable from "../tables/FeatureTable.vue";

@Component({
  components: {
    FeatureTable,
  },
})
export default class ManageFeaturesDialog extends Vue {
  dialog: boolean = false;
}
